export var noJSHandler = function () {
    var elements = document.querySelectorAll('.no-js');
    elements.forEach(function (element) {
        element.classList.remove('no-js');
    });
    var noJsElements = document.querySelectorAll('.js-no-js-element');
    noJsElements.forEach(function (element) {
        element.remove();
    });
};
